module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/yoga-9f1ac87470d7c56921a3833a8106bf6a.png";